// src/db.js
import Dexie from 'dexie';

export const db = new Dexie("OfflineDB");
db.version(1).stores({
    entries: "++id,name,quantity,status"
});
